import axios from 'axios';

export function getAppConfig() {
  return axios<AppConfig>(`/app/config`, {
    method: 'GET',
  }).then(res => res.data);
}
